import React from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { CheckBox, Loader, Helper } from 'Components';
import TestPickListPackage from './TestPickListPackage/TestPickListPackage';
import './TestPickList.css';

const testsContain = (Package, key, s) => {
  if (Package.Tests === undefined) return false;

  for (let t = 0; t < Package.Tests.length; t += 1) {
    if (Package.Tests[t][key] !== null &&
      Package.Tests[t][key].toLowerCase().includes(s)) return true;
  }

  return false;
};

const parametersContain = (Package, key, s) => {
  if (Package.Tests === undefined) return false;

  for (let t = 0; t < Package.Tests.length; t += 1) {
    if (Package.Tests[t].Parameters === undefined) return false;
    for (let p = 0; p < Package.Tests[t].Parameters.length; p += 1) {
      if (Package.Tests[t].Parameters[p][key].toLowerCase().includes(s)) return true;
    }
  }

  return false;
};

const isIncluded = (search, Package) => {
  if (search === undefined) return true;
  const s = [...new Set(search.toLowerCase().split(' '))].filter(item => item.length > 0);
  if (search === '') return true;

  const checkForAllWords = s.map(item => (
    Package.MatrixCode.toLowerCase().includes(item) ||
    Package.MatrixName.toLowerCase().includes(item) ||
    Package.PackageName.toLowerCase().includes(item) ||
    Package.PackageCode.toLowerCase().includes(item) ||
    (Package.QuoteGroupCode != null && Package.QuoteGroupCode.toLowerCase().includes(item)) ||
    (Package.QuoteGroupName != null && Package.QuoteGroupName.toLowerCase().includes(item)) ||
    (Package.ProfileName != null && Package.ProfileName.toLowerCase().includes(item)) ||
    testsContain(Package, 'TestName', item) ||
    testsContain(Package, 'TestCode', item) ||
    testsContain(Package, 'MethodReference', item) ||
    testsContain(Package, 'ProfileName', item) ||
    testsContain(Package, 'QuoteGroupName', item) ||
    testsContain(Package, 'QuoteGroupCode', item) ||
    parametersContain(Package, 'ParameterName', item)));

  return checkForAllWords.every(v => v);
};

const TestPickList = ({
  search,
  Packages,
  onCheck,
  onCheckAll,
  onCollapse,
  onTestCollapse,
  onParameterCheck,
  onParameterCheckAll,
  isLoading,
  isSearching,
  selectedKeys,
  isTestHeaderShown,
  toolTip,
  isShowingNoResultFoundMessage,
  bin,
}) => {
  const nonReadOnlyPackages = Packages.filter(item => !item.IsReadOnly);
  const isAllSelected = nonReadOnlyPackages.length !== 0 && nonReadOnlyPackages.every(x => x.checked);

  return (
    <div className="test-pick-list">
      <ul className="test-pick-list__options">
        { isLoading && <Loader />}
        { !isSearching && !Packages.every(Package => selectedKeys.includes(Package.key)) && (
          <li className="test-pick-list__options__header">
            <Helper text={toolTip}>
              <CheckBox checked={isAllSelected} onClick={onCheckAll} />
            </Helper>
            <div>{i18n.t('common:SelectAll')}</div>
          </li>)
        }
        {
          isShowingNoResultFoundMessage &&
          <div className="test-pick-list__no-result-found-message">
            <p>{i18n.t('formsTests:NoRecommendedTestsFound')}</p>
          </div>
        }
        {
          Packages.map((Package, p) => (
            <TestPickListPackage
              {...Package}
              key={`${bin}-${Package.key}`}
              bin={bin}
              isTestHeaderShown={isTestHeaderShown}
              onCheck={() => onCheck(p)}
              onParameterCheck={(t, m) => onParameterCheck(p, t, m)}
              onParameterCheckAll={t => onParameterCheckAll(p, t)}
              onTestCollapse={t => onTestCollapse(p, t)}
              onCollapse={() => onCollapse(p)}
              isHidden={selectedKeys.includes(Package.key) || !isIncluded(search, Package)}
            />
          ))
        }
      </ul>
    </div>
  );
}


TestPickList.propTypes = {
  search: PropTypes.string,
  Packages: PropTypes.arrayOf(PropTypes.shape({ })),
  onCheck: PropTypes.func,
  onParameterCheck: PropTypes.func,
  onParameterCheckAll: PropTypes.func,
  onCheckAll: PropTypes.func,
  onCollapse: PropTypes.func,
  onTestCollapse: PropTypes.func,
  isLoading: PropTypes.bool,
  selectedKeys: PropTypes.arrayOf(PropTypes.string),
  isTestHeaderShown: PropTypes.bool,
  isSearching: PropTypes.bool,
  toolTip: PropTypes.string,
  isShowingNoResultFoundMessage: PropTypes.bool,
  bin: PropTypes.string,
};

TestPickList.defaultProps = {
  Packages: [],
  isLoading: false,
  selectedKeys: [],
  isTestHeaderShown: false,
  toolTip: '',
  isShowingNoResultFoundMessage: false,
  bin: '',
};

export default TestPickList;



// WEBPACK FOOTER //
// ./src/components/TestPickList/TestPickList.jsx